import { ErrorMessage } from '#components/atoms/forms/index.ts';
import { ConfirmDialog } from '#components/patterns/confirmations/confirm-dialog/ConfirmDialog.tsx';

type Props = {
  onAccept: () => void;
  onCancel: () => void;
  errorMessage?: string | null;
};

/**
 * Shown to users requesting to cancel their Pro plan and downgrade to the Free plan.
 */
export function DowngradePlanModal({ onAccept, onCancel, errorMessage }: Props) {
  return (
    <ConfirmDialog title="Downgrade your plan" onAccept={onAccept} onCancel={onCancel} isOpen>
      {errorMessage ?
        <ErrorMessage className="mb-16">{errorMessage}</ErrorMessage>
      : null}
      <p className="p">
        By downgrading your plan, your network will remain operational but will be restricted to 100 hosts.
      </p>
      <p className="p">
        Accounts with over 100 hosts at the time of downgrade will not be able to create additional hosts or re-enroll
        existing hosts.
      </p>
    </ConfirmDialog>
  );
}
